export const ENDPOINTS = {
  NORMATIVAS: "/normativa",
  NORMATIVAS_POR_ALCANCE: "/normativa/alcance",
  NORMATIVAS_NO_ASOCIADAS_CANTIDAD: "/normativa/cantidad-no-asociada",
  DOCUMENTACION_ADJUNTA: "/documentacion-adjunta",
  USERS: "/users",
  AUTH: "/auth",
  DOCUMENTACION_ADJUNTA_VER_FILE: "/documentacion-adjunta/file",
  TIPO_EFECTO: "/tipo-efecto",
  TIPO_NORMATIVA: "/tipo-normativa",
  DISEÑOS_CURRICULARES: "/disenio-curricular",
  DISEÑOS_cURRICULARES_COUNT: "/disenio-curricular/count",
  ESTADOS: "/estado",
  ALCANCES: "/alcance",
  TITULOS: "/titulo",
  ORGANISMO: "/organismo",
  ORGANISMO_ALL: "/organismo/all",
  INFORMACION_GENERAL: "/info-general",
  PLANES_ESTUDIO: "/plan-estudio",
  PLANES_ESTUDIO_COUNT: "/plan-estudio/count",
  PLANES_ESTUDIO_COUNT_VALIDADOS: "/plan-estudio/count-validados",
  PLANES_ESTUDIO_VALIDEZ_VENCIDA: "/plan-estudio/cantidad-validez-vencida",
  OPCION_PEDAGOGICA: "/opcion-pedagogica",
  MODALIDAD: "/modalidad",
  MODALIDAD_PAGINADO: "/modalidad/paginado",
  AREA: "/areas",
  NIVELES: "/nivel",
  NIVELES_PAGINADO: "/nivel/paginado",
  ORIENTACIONES: "/orientacion",
  CERTIFICACIONES: "/certificacion",
  CERTIFICACIONES_PAGINADO: "/certificacion/paginado",
  TIPO_ESPACIO: "/tipo-espacio",
  ESPACIOS_CURRICULARES: "/espacio-curricular",
  CICLO: "/ciclo",
  ESPECIALIDAD: "/especialidad",
  COMBINATORIA: "/modalidad-nivel-opcion-pedagogica",
  CAJAS_CURRICULARES: "/caja-curricular",
  VALIDACION_NACIONAL: "/validacion-nacional",
  VALIDACION_NACIONAL_EXPEDIENTE_INTERNO:
    "/validacion-nacional/expediente-interno",
  VALIDACION_NACIONAL_CANTIDAD_PLANES_POR_VENCER:
    "/validacion-nacional/cantidad-planes-por-vencer",
  ESTADO_VALIDACION_NACIONAL: "/estado-validacion-nacional",
  PCI: "/pci",
  CAJA_CURRICULAR_PCI: "/caja_curricular_pci",
  ESPACIO_CURRICULAR_PCI: "/espacio-curricular-pci",
  INSTITUCION: "/institucion",
};
